import { TransportUnitId, TransportUnitNode } from '../types';

// Maps each transport unit to its hierarchical position label ("1", "1.2", "2.1.3"), mirroring the
// numbering PackingListSection/TransportUnitCard render (top-level `index + 1`, children joined with
// a dot). Used to tell the user which unit a placed item is being moved from.
export const getTransportUnitPositions = (units: Array<TransportUnitNode>): Map<TransportUnitId, string> => {
  const positions = new Map<TransportUnitId, string>();
  const walk = (nodes: Array<TransportUnitNode>, prefix: string) => {
    nodes.forEach((node, index) => {
      const position = prefix ? `${prefix}.${index + 1}` : String(index + 1);
      positions.set(node.id, position);
      walk(node.children, position);
    });
  };
  walk(units, '');
  return positions;
};

// Orders two position labels the way the units are laid out on screen: segment by segment, comparing
// each numerically ("2" after "10" would be wrong under a plain string sort, and "1.2" sorts before
// "1.10"). Shorter positions (a parent) come before their descendants.
export const compareTransportUnitPositions = (a: string, b: string): number => {
  const aSegments = a.split('.').map(Number);
  const bSegments = b.split('.').map(Number);
  for (let i = 0; i < Math.max(aSegments.length, bSegments.length); i += 1) {
    const diff = (aSegments[i] ?? 0) - (bSegments[i] ?? 0);
    if (diff !== 0) {
      return diff;
    }
  }
  return 0;
};
